/* eslint-disable no-console */
import { NextWebVitalsMetric } from 'next/app'

export function reportWebVitalsToConsole(metric: NextWebVitalsMetric): void {
  console.groupCollapsed(`webvitals / ${metric.name}`)
  console.debug(metric)
  console.groupEnd()
}
